import { jsx as t, jsxs as r } from "react/jsx-runtime";
import { useState as v } from "react";
import { ProductCardUnavailable as x } from "../ProducCardUnavailable/index.js";
import { ProductCardBadgeKg as y } from "../ProductCardBadge/ProductCardBadgeKg.js";
import { ProductCardDiscountBadge as z } from "../ProductCardBadge/ProductCardDiscountBadge.js";
import { ProductCardButton as b } from "../ProductCardButton/index.js";
import { ProductCardImage as M } from "../ProductCardImage/index.js";
import { ProductCardName as N } from "../ProductCardName/index.js";
import { ProductCardPrice as O } from "../ProductCardPrice/index.js";
import { ProductCardPromotionFlag as p } from "../ProductCardPromotionFlag/index.js";
const G = ({
  hasPlusFriendBadge: a,
  promotion: i,
  product: e,
  hasPromotionalPrice: c,
  clubPrice: C,
  outOfStock: o,
  variant: s,
  defaultScListPrice: l,
  isClubClient: u,
  addToCartAction: P,
  quantitySelectorAction: g,
  productInCart: h,
  openModal: S
}) => {
  var d, f;
  const [k, m] = v(!1);
  if (o)
    return /* @__PURE__ */ t(
      x,
      {
        image: (d = e.image) == null ? void 0 : d[0],
        name: e.name,
        variant: "horizontal"
      }
    );
  const n = u && e.hasClubPrice;
  return /* @__PURE__ */ r(
    "div",
    {
      className: "product-card-horizontal",
      style: {
        backgroundColor: o ? "var(--color-grayScale-faded" : "#fff"
      },
      children: [
        /* @__PURE__ */ r(
          "div",
          {
            onClick: S,
            className: "product-card-section-product-horizontal",
            children: [
              /* @__PURE__ */ t(
                M,
                {
                  isProductClubAndClient: n,
                  variant: s,
                  hasPlusFriendBadge: a,
                  promotion: i,
                  image: (f = e.image) == null ? void 0 : f[0]
                }
              ),
              /* @__PURE__ */ r(
                "div",
                {
                  className: "product-card-horizontal-description",
                  style: {
                    backgroundColor: n ? "#FDF3DE" : "var(--color-grayScale-faded)"
                  },
                  children: [
                    /* @__PURE__ */ r("div", { className: "product-card-section-name", children: [
                      /* @__PURE__ */ t(N, { name: e.name }),
                      /* @__PURE__ */ r(
                        "div",
                        {
                          className: "product-card-section-badge-horizontal",
                          style: { display: k ? "" : "none" },
                          children: [
                            /* @__PURE__ */ t(
                              y,
                              {
                                unitMultiplier: e.unitMultiplier,
                                skuSpecifications: e.skuSpecifications,
                                measurementUnit: e.measurementUnit,
                                setIsShowProductBadge: m
                              }
                            ),
                            /* @__PURE__ */ t(
                              z,
                              {
                                defaultScListPrice: l,
                                nativeListPrice: e.customOffers.listPriceCustom,
                                nativeSpotPrice: e.customOffers.spotPriceCustom,
                                skuSpecifications: e.skuSpecifications,
                                unitMultiplier: e.unitMultiplier,
                                hasPromotionalPrice: c,
                                setIsShowProductBadge: m
                              }
                            )
                          ]
                        }
                      )
                    ] }),
                    s === "horizontal" && /* @__PURE__ */ t(
                      p,
                      {
                        variant: s,
                        productSectionBadge: {
                          text: i == null ? void 0 : i.flagText,
                          color: {
                            textColor: i == null ? void 0 : i.textColor,
                            backGroundColor: i == null ? void 0 : i.colorCode
                          }
                        }
                      }
                    ),
                    /* @__PURE__ */ t(
                      O,
                      {
                        isClubClient: u,
                        unitMultiplier: e.unitMultiplier,
                        hasPromotionalPrice: c,
                        measurementUnit: e.measurementUnit,
                        skuSpecifications: e.skuSpecifications,
                        customOffers: {
                          listPriceCustom: e.customOffers.listPriceCustom,
                          hasDiscount: e.customOffers.hasDiscount,
                          spotPriceCustom: e.customOffers.spotPriceCustom,
                          spotPriceKg: e.customOffers.spotPriceCustom
                        },
                        defaultScListPrice: l,
                        clubPrice: C,
                        hasPlusFriendBadge: a
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ t(
          b,
          {
            addToCartAction: P,
            quantitySelectorAction: g,
            productInCart: h,
            layout: s
          }
        )
      ]
    }
  );
};
export {
  G as ProductCardHorizontal
};
